export default {"src":"/_next/static/media/laptop-phone.156352bd.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};